import { Weapon } from '../Weapon.js';
import { WEAPONS } from '../../../../config/constants.js';

/**
 * Scatter Cannon — fires a cone of pellets toward the boss.
 * Spread tightens and pellet count increases with level. At level 3+ a
 * second, staggered cone wave follows shortly after the first, and at
 * level 8 (capstone) a third follows further behind that — each queued as
 * a seconds-remaining entry (not the base fire-rate timer) so every wave
 * lands against wherever the player/boss actually are a beat later, not
 * the positions captured when the first wave fired. A queue (not a single
 * pending flag) is needed since two waves can be in flight at once once
 * the third unlocks.
 */
export class ScatterCannon extends Weapon {
  constructor() {
    super(WEAPONS.scatterCannon);
    this._pendingWaves = []; // seconds-remaining until each queued wave fires
  }

  update(dt, origin, target, pool) {
    super.update(dt, origin, target, pool);
    for (let i = this._pendingWaves.length - 1; i >= 0; i--) {
      this._pendingWaves[i] -= dt;
      if (this._pendingWaves[i] <= 0) {
        this._pendingWaves.splice(i, 1);
        this._fireCone(origin, target, pool);
      }
    }
  }

  fire(origin, target, pool) {
    this._fireCone(origin, target, pool);
    if (this.level >= 3) this._pendingWaves.push(0.12);
    if (this.level >= 8) this._pendingWaves.push(0.24); // third wave, staggered further behind the second
  }

  _fireCone(origin, target, pool) {
    const dx = target.x - origin.x;
    const dy = target.y - origin.y;
    const baseAngle = Math.atan2(dy, dx);

    const pellets = this.config.pellets + Math.floor((this.level - 1) / 2);
    const spread = Math.max(0.2, this.config.spread - this.level * 0.04);
    const dmg = this.config.damage + this.level;

    for (let i = 0; i < pellets; i++) {
      const t = pellets === 1 ? 0 : (i / (pellets - 1)) * 2 - 1;
      const angle = baseAngle + t * spread;
      const speed = this.config.projectileSpeed + (this.level >= 3 ? 40 : 0);

      pool.fire({
        x: origin.x,
        y: origin.y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        radius: this.config.projectileRadius,
        damage: dmg,
        lifetime: this.config.lifetime,
        color: this.config.color,
      });
    }
  }
}
